import React from "react";

type ScrollContainerProps = {
  children?: React.ReactNode
};

export class ScrollContainer extends React.Component<ScrollContainerProps> {
  render() {
    return <div className="maputnik-scroll-container">
      {this.props.children}
    </div>;
  }
}
